module.exports = __webpack_public_path__ + "img/busqueda.02f21080.svg";